import { Dialog, DialogTitle, DialogBody } from "V2.0/common/dialog";
import { Button } from "V2.0/common/button";
import { useState } from "react";
import { PlusIcon } from "@heroicons/react/20/solid";
import { ExtractionParameterForm } from "./ExtractionParamterForm";

const defaultExtractionParameter = {
  parameterName: "",
  parameterDescription: "",
  parameterType: "",
  parameterChoices: [],
  isMandatoryField: false
};

function ExtractionParameterAdd(props) {
  const { onAddExtractionParameter } = props;
  const [open, setOpen] = useState(false);

  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);

  return (
    <>
      <Button onClick={onOpen}>
        <PlusIcon />
        Add Field
      </Button>
      {open && (
        <Dialog open={open} onClose={onClose}>
          <DialogTitle>Add Field</DialogTitle>
          <DialogBody>
            <ExtractionParameterForm
              extractionParameter={defaultExtractionParameter}
              onSave={onAddExtractionParameter}
              onCancel={onClose}
            />
          </DialogBody>
        </Dialog>
      )}
    </>
  );
}

export default ExtractionParameterAdd;
